import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HandlingUnitMaterialSearchCriteria } from '../../../models';
import { getQueryStringFromObject } from '../../../../../../common/utils';
import { HandlingUnitEndpoint } from '../../../constants/handling-unit-endpoint';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../../services/config';
import { HandlingUnitMaterialsStateModel } from './handling-unit-materials.state';

@Injectable({
  providedIn: 'root',
})
export class HandlingUnitMaterialsService {
  constructor(private http: WrapperHttpService) {}

  getHandlingUnits(
    deliveryNoteNumber: string,
    handlingUnitNumber: string,
    searchCriteria: HandlingUnitMaterialSearchCriteria,
  ): Observable<HandlingUnitMaterialsStateModel> {
    const url =
      `${API_URL}${HandlingUnitEndpoint.Base}${HandlingUnitEndpoint.Monitoring}${HandlingUnitEndpoint.DeliveryNote}/${deliveryNoteNumber}${HandlingUnitEndpoint.HandlingUnit}/${handlingUnitNumber}${HandlingUnitEndpoint.Materials}?` +
      getQueryStringFromObject(searchCriteria);
    return this.http.withLoading().get<HandlingUnitMaterialsStateModel>(url);
  }
}
